import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Heading = styled.div`
	font-size: 2rem;
	line-height: 3rem;
	font-weight: 700;
	color: ${colors.white};
`;
